import {
    login,
    getInfo,
    logout,
    refreshToken,
    refreshMicroToken,
    microLogin
} from '../../api/login'
import {
    setToken,
    getToken,
    getExpiresToken,
    removeToken
} from '../../servises/token'
import {
    setMicroToken,
    getMicroToken,
    getMicroExpiresToken,
    removeMicroToken,

} from '../../servises/microToken'
import store from '../'

const state = {
    token: getToken(),
    expires_token: +getExpiresToken(),
    userData: null,
    micro_token: getMicroToken(),
    expires_micro_token: +getMicroExpiresToken(),
}

const getters = {
    token: state => state.token,
    userData: state => state.userData,
    micro_token: state => state.micro_token,
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_EX_TOKEN: (state, data) => {
        state.expires_token = data
    },
    SET_USER: (state, data) => {
        state.userData = data
    },
    SET_MICRO_TOKEN: (state, token) => {
        state.micro_token = token
    },
    SET_EX_MICRO_TOKEN: (state, data) => {
        state.expires_micro_token = data
    },
}

const actions = {
    Login: ({
        commit,
        dispatch
    }, data) => {
        return new Promise((resolve, reject) => {
            login(data.email, data.password, data.remember).then(r => {
                setToken(r)
                commit('SET_TOKEN', r)
                commit('SET_EX_TOKEN', r.expires_in - 20)
                dispatch('SET_LOGIN', null, {
                    root: true
                })
                resolve()
            }).catch(err => {
                console.dir(err)
                reject(err)
            });
            microLogin(data.email, data.password, data.remember).then(r => {
                setMicroToken(r)
                commit('SET_MICRO_TOKEN', r)
                commit('SET_EX_MICRO_TOKEN', r.expires_in - 20)
                resolve()
            }).catch(err => {
                console.dir(err)
                reject(err)
            })
        })
    },
    GetInfo({
        commit,
        state
    }) {
        return new Promise((resolve, reject) => {
            getInfo(state.token).then(response => {
                commit('SET_USER', response)
                refreshTimetToken()
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    LogOut({
        commit,
        state,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            logout(state.token)
                .then((r) => {
                    commit('SET_TOKEN', '')
                    commit('SET_USER', null)
                    removeToken()
                    dispatch('SET_LOG_OUT')
                    resolve(r.message)
                    commit('SET_MICRO_TOKEN', '')
                    removeMicroToken()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    MicroFedLogOut({
        commit
    }) {
        return new Promise(resolve => {
            removeMicroToken()
            commit('SET_MICRO_TOKEN', '')
            resolve()
        })
    },
    FedLogOut({
        commit
    }) {
        return new Promise(resolve => {
            removeToken()
            commit('SET_TOKEN', '')
            resolve()
        })
    },
    refreshToken({ commit }) {
        return new Promise((resolve, reject) => {
            refreshToken()
                .then(response => {
                    setToken(response)
                    commit('SET_TOKEN', response)
                    commit('SET_EX_TOKEN', response.expires_in)
                })
                .catch(error => {
                    console.dir(error)
                    reject(error)
                })
        })
    },
    refreshMicroToken({ commit }) {
        return new Promise((resolve, reject) => {
            refreshMicroToken()
                .then(response => {
                    setMicroToken(response)
                    commit('SET_MICRO_TOKEN', response)
                    commit('SET_EX_MICRO_TOKEN', response.expires_in)
                })
                .catch(error => {
                    console.dir(error)
                    reject(error)
                })
        })
    },
}


function refreshTimetToken() {
    const timer = (state.expires_token - 100) * 1000 || 100000
    setTimeout(function() {
        store.dispatch('refreshToken');
        store.dispatch('refreshMicroToken')
        refreshTimetToken()
    }, timer)
}



export default {
    state,
    getters,
    actions,
    mutations,
}